/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import {
  BaseMutationModel,
  IMutationModelOpts,
  useGqlClient,
} from '@r-client/shared/data/client';
import { useLocalObservable } from 'mobx-react-lite';
import {
  IUserEmailConfirmationResendMutation,
  UserEmailConfirmationResendDocument,
  IUserEmailConfirmationResendMutationVariables,
} from './types';
import { IUserEmailConfirmationResendPayload } from '@r-client/data/graphql-types';
export type { IUserEmailConfirmationResendPayload };

export class UserEmailConfirmationResendMutation extends BaseMutationModel<
  IUserEmailConfirmationResendMutation,
  IUserEmailConfirmationResendMutationVariables
> {
  get mutation() {
    return UserEmailConfirmationResendDocument;
  }
}
export function useUserEmailConfirmationResendMutation(
  opts?: Omit<
    IMutationModelOpts<IUserEmailConfirmationResendMutationVariables>,
    'client'
  >
) {
  const client = useGqlClient();
  return useLocalObservable(
    () => new UserEmailConfirmationResendMutation({ ...opts, client })
  );
}
